class Selections {
  updateFetchPeopleDataCount() {
    console.log("updateFetchPeopleDataCount FUNCTION CALLED");
    var fetch_people_data_count = document.getElementById("fetch_people_data_count").value;
    console.log(fetch_people_data_count);
    sessionStorage["fetch_people_data_count"] = fetch_people_data_count;
  }

  updateFetchCompaniesDataCount() {
    console.log("updateFetchCompaniesDataCount FUNCTION CALLED");
    var fetch_companies_data_count = document.getElementById("fetch_companies_data_count").value;
    console.log(fetch_companies_data_count);
    sessionStorage["fetch_companies_data_count"] = fetch_companies_data_count;
  }

  updateFetchNodesDataCount() {
    console.log("updateFetchNodesDataCount FUNCTION CALLED");
    var fetch_nodes_data_count = document.getElementById("fetch_nodes_data_count").value;
    console.log(fetch_nodes_data_count);
    if (fetch_nodes_data_count > 100) {
      // showToastLimitof100()
      sessionStorage["fetch_nodes_data_count"] = 100;
      document.getElementById("pick_function_error_node").innerHTML = '<br><span style="color:red">Fetching more than 100 results in one go disabled</span>';
      document.getElementById("fetch_nodes_data_count").value = 100;
      new Selections().updateFetchNodesDataCount();
    } else {
      sessionStorage["fetch_nodes_data_count"] = fetch_nodes_data_count;
    }
  }

  updateNewCreditBalance(user_input) {
    console.log("updateNewCreditBalance FUNCTION CALLED");
    sessionStorage["new_credit_balance"] = user_input.value;
  }

  updatePlanRadio(user_input) {
    console.log("updatePlanRadio FUNCTION CALLED");
    var new_plan = user_input.getAttribute("new_plan");
    sessionStorage["new_plan"] = new_plan;
  }

  updateRawStringQueryInputText(user_input) {
    sessionStorage["raw_string_query_input"] = user_input.value;
  }

  updateProjectNameInputText(user_input) {
    sessionStorage["job_name"] = user_input.value;
  }

  updateSearchAccount(user_input) {
    console.log("updateSearchAccount FUNCTION CALLED");

    sessionStorage["accounts_to_search"] = user_input.value;
    displayAccounts();
  }

  updateComment(user_input) {
    console.log("updateComment FUNCTION CALLED");

    sessionStorage["user_comment"] = user_input.value;
  }

  updateSearchKeyword(user_input) {
    console.log("updateSearchKeyword FUNCTION CALLED");
    sessionStorage["search_keyword"] = user_input.value;
  }

  updateDataOption(user_input) {
    console.log("updateDataCoverage FUNCTION CALLED");
    var data_coverage = user_input.getAttribute("data_option");
    console.log(data_coverage);
    sessionStorage["data_option"] = data_coverage;
    new Query().fetchQueryShowResults("cost_credits");
    // calculateRequiredCredits()
  }

  updateDataCoverage(user_input) {
    console.log("updateDataCoverage FUNCTION CALLED");
    var data_coverage = user_input.getAttribute("data_coverage");
    console.log(data_coverage);
    sessionStorage["data_coverage"] = data_coverage;
    new Query().fetchQueryShowResults("cost_credits");
    // calculateRequiredCredits()
  }

  updatedataSourceRadio(user_input) {
    console.log("updatedataSourceRadio FUNCTION CALLED");
    var data_source = user_input.getAttribute("data_source");
    console.log(data_source);
    sessionStorage["data_source"] = data_source;
    new Query().fetchQueryShowResults("cost_credits");
    // calculateRequiredCredits()
  }

  selectNewAccountUseCase(user_input) {
    console.log("selectCountryName FUNCTION CALLED");
    var use_case = user_input.getAttribute("use_case");
    var label = user_input.getAttribute("label");
    console.log(user_input);
    console.log(label);
    sessionStorage["use_case"] = use_case;
    sessionStorage["use_case_selected"] = "yes";
    try {
      document.getElementById("new_account_use_case").innerHTML = label;
    } catch (error) {
      console.log("Error:", error);
    }
    try {
      document.getElementById("new_account_use_case_mobi").innerHTML = label;
    } catch (error) {
      console.log("Error:", error);
    }

    document.getElementById("pick_function_error").innerHTML = "";
    // calculateRequiredCredits()
  }

  selectFunctionalArea(user_input) {
    console.log(user_input);
    var updateTokenObj = user_input.getAttribute("functional_area");
    console.log(updateTokenObj);
    updateStorageToken(updateTokenObj, "functional_area");
    new Query().fetchQueryShowResults();
  }

  selectGeoArea(user_input) {
    console.log(user_input);
    var updateTokenObj = user_input.getAttribute("country");
    console.log(updateTokenObj);
    updateStorageToken(updateTokenObj, "selectGeoArea");
    new Query().fetchQueryShowResults();
  }

  selectPositionFetchData(user_input) {
    var positions_required = user_input.getAttribute("positions_required");
    var label = user_input.getAttribute("label");
    sessionStorage["positions_required1"] = positions_required;
    // sessionStorage['positions_required_selection_made'] = 'yes'
    document.getElementById("pick_function_error").innerHTML = "";
    document.getElementById("select_positions_dropdown").innerHTML = label;
    // calculateRequiredCredits()
  }

  selectFunctionsTreeFunctionsItem(user_input) {
    console.log("This is the selectFunctionsTreeFunctionsItem user_inputuser_input", user_input);
    var function_name = user_input.getAttribute("function_name");
    sessionStorage["selectFunctionsTreeFunctionsItem"] = "true";

    var token_obj = { std_function: function_name };
    updateStorageToken(token_obj, "selectFunctionsTreeFunctionsItem");
    console.log("selectFunctionsTreeFunctionsItem FUNCTION CALLED");

    document.getElementById("functions_tree_dropdown_button").innerHTML = function_name;

    // label = user_input.getAttribute("label")
    // updateStorageToken('functions_tree_dropdown', label)
    // sessionStorage['positions_required_selection_made'] = 'yes'
    document.getElementById("pick_function_error").innerHTML = "";

    new Query().fetchQueryShowResults("cost_credits");
  }

  selectFunctionsTreeFunctionsRootItem(user_input) {
    console.log("This is the selectFunctionsTreeFunctionsRootItem user_inputuser_input", user_input);
    sessionStorage["selectFunctionsTreeFunctionsRootItem"] = "true";
    var function_root = user_input.getAttribute("function_root");

    document.getElementById("functions_tree_dropdown_button").innerHTML = function_root;
    var token_obj = { function_root: function_root };
    updateStorageToken(token_obj, "selectFunctionsTreeFunctionsRootItem");
    console.log("selectFunctionsTreeFunctionsRootItem FUNCTION CALLED");
    document.getElementById("pick_function_error").innerHTML = "";
    new Query().fetchQueryShowResults("cost_credits");
  }

  selectGradesDropdownData(user_input) {
    console.log("selectGradesItem FUNCTION CALLED");

    console.log("This is the selectGradesDropdownData user_inputuser_input", user_input);
    var grades = user_input.getAttribute("grades");
    sessionStorage["selectGradesItem"] = "true";
    document.getElementById("select_grades_dropdown").innerHTML = grades;
    var token_obj = { grades: grades };
    updateStorageToken(token_obj, "selectGradesItem");

    document.getElementById("pick_function_error").innerHTML = "";
    new Query().fetchQueryShowResults("cost_credits");
  }

  selectLocationsFetchData1(user_input) {
    console.log("selectLocationsFetchData1 FUNCTION CALLED");
    document.getElementById("modal_locations_dropdown2").innerHTML = "";
    document.getElementById("modal_locations_dropdown3").innerHTML = "";
    document.getElementById("pick_function_error_node").innerHTML = "";

    var locations_required = user_input.getAttribute("locations_required");
    console.log(locations_required);
    console.log(label);
    var label = user_input.getAttribute("label");
    updateStorageToken("locations_required1", label);
    sessionStorage["locations_dropdown1"] = label;
    // sessionStorage['positions_required_selection_made'] = 'yes'
    document.getElementById("pick_function_error").innerHTML = "";
    document.getElementById("select_locations_dropdown_1").innerHTML = label;
    new Query().fetchQueryShowResults("locations_dropdown2");
    new Query().fetchQueryShowResults("cost_credits");

    // selectLocationsFetchData2(user_input)
  }

  selectLocationsFetchData2(user_input) {
    console.log("selectLocationsFetchData2 FUNCTION CALLED");

    document.getElementById("modal_locations_dropdown3").innerHTML = "";
    document.getElementById("pick_function_error_node").innerHTML = "";
    var locations_required = user_input.getAttribute("locations_required");
    var label = user_input.getAttribute("label");
    updateStorageToken("locations_required2", label);
    console.log(locations_required);
    console.log(label);
    sessionStorage["locations_dropdown2"] = label;
    // sessionStorage['positions_required_selection_made'] = 'yes'
    document.getElementById("pick_function_error").innerHTML = "";
    document.getElementById("select_locations_dropdown_2").innerHTML = label;
    new Query().fetchQueryShowResults("locations_dropdown3");
    new Query().fetchQueryShowResults("cost_credits");

    // selectLocationsFetchData2(user_input)
  }

  selectLocationsFetchData3(user_input) {
    console.log("selectLocationsFetchData3 FUNCTION CALLED");
    document.getElementById("pick_function_error_node").innerHTML = "";
    let locations_required = user_input.getAttribute("locations_required");
    var label = user_input.getAttribute("label");
    updateStorageToken("locations_required3", label);
    console.log(locations_required);
    console.log(label);
    sessionStorage["locations_dropdown3"] = label;
    // sessionStorage['positions_required_selection_made'] = 'yes'
    document.getElementById("pick_function_error").innerHTML = "";
    document.getElementById("select_locations_dropdown_3").innerHTML = label;
    new Query().fetchQueryShowResults("cost_credits");

    // selectLocationsFetchData2(user_input)
  }
}

class ManageContactsFetching {
  setupContactData(person_id, person_linkedin_url, type_contact_info) {
    var token_obj = {
      person_linkedin_url: person_linkedin_url,
      person_id: person_id,
    };
    updateStorageToken(token_obj, "contactInfoClicked");

    if (type_contact_info == "contact_card_") {
      new Query().fetchQueryShowResults("contact_info");
    } else if ((type_contact_info = "see_more_")) {
      new Query().fetchQueryShowResults("contact_info_org_charts");
    }
  }

  mouseOutWhatsapp(element) {
    console.log("Clicked mouseOutWhatsapp");

    var whatsapp = element.getAttribute("whatsapp");
    var newValue = whatsapp + "<br/>Click to Message";
    // navigator.clipboard.writeText(email1);

    // jQuery(element).attr('data-original-title', newValue).tooltip('hide');
    jQuery(element).attr("data-original-title", newValue);
  }

  mouseOutEmailLink(element) {
    // console.log("Clicked mouseOutEmailLink")
    // console.log("Clicked mouseOutPhoneLink")
    var email1 = element.getAttribute("email");
    var newValue = email1 + "<br/>Click to copy";
    // navigator.clipboard.writeText(email1);

    // jQuery(element).attr('data-original-title', newValue).tooltip('hide');
    jQuery(element).attr("data-original-title", newValue);
  }

  mouseOutPhoneLink(element) {
    // console.log("Clicked mouseOutPhoneLink")
    var phone = element.getAttribute("phone");
    var newValue = phone + "<br/>Click to copy";
    // navigator.clipboard.writeText(email1);

    // jQuery(element).attr('data-original-title', newValue).tooltip('hide');
    jQuery(element).attr("data-original-title", newValue);
    //   .tooltip('fixTitle')
    //   .tooltip('show');
  }

  clickedSeeMoreWhatsappLink(element, phone) {
    console.log("Clicked clickedSeeMoreWhatsappLink");
    var existing_value = element.getAttribute("data-original-title");
    var newValue = existing_value.replace("Click to copy", "Copied");
    // jQuery(element).attr('data-original-title', newValue).tooltip('hide');
    var message = "Hello";
    window.open("https://api.whatsapp.com/send/?phone=+" + phone + "&text=" + message + "&type=phone_number", "_blank");
  }

  clickedSeeMoreEmailLink(element) {
    console.log("Clicked clickedSeeMoreEmailLink");
    var existing_value = element.getAttribute("data-original-title");
    var email = existing_value.replace("<br/>Click to copy", "");
    var newValue = existing_value.replace("Click to copy", "Copied");
    navigator.clipboard.writeText(email);
    // jQuery(element).attr('data-original-title', newValue).tooltip('hide');
    jQuery(element)
      .tooltip("hide")
      .attr("data-original-title", newValue)
      //   .tooltip('fixTitle')
      .tooltip("show");
  }

  clickedSeeMorePhoneLink(element, phone) {
    console.log("Clicked clickedSeeMorePhoneLink");
    navigator.clipboard.writeText(phone);
    var existing_value = element.getAttribute("data-original-title");
    var newValue = existing_value.replace("Click to copy", "Copied");
    jQuery(element).attr("data-original-title", newValue).tooltip("hide");
    jQuery(element)
      .tooltip("hide")
      .attr("data-original-title", newValue)
      //   .tooltip('fixTitle')
      .tooltip("show");
  }

  emailPhoneNumberClicked(user_input) {
    console.log("emailPhoneNumberClicked called");
    console.log("emailPhoneNumberClicked user input:::", user_input);
    var person_id = user_input.getAttribute("person_id");
    var person_linkedin_url = user_input.getAttribute("person_linkedin_url");
    console.log(person_id);
    var selector = document.querySelector('[person_id="' + person_id + '"]');
    selector.innerHTML = document.getElementById("loader_people_contact_card_element").innerHTML;
    var token_obj = {
      person_linkedin_url: person_linkedin_url,
      person_id: person_id,
    };
    updateStorageToken(token_obj, "contactInfoClicked");
    console.log(selector);
    new Query().fetchQueryShowResults("contact_info");
    new Tokens().resetSessionStorageTokensForContactInfo();
  }

  clickedContactLinkImage(element) {
    // console.log("Clicked clickedContactLinkImage:: with element::,", element)

    // element = document.getElementById("contact_link_image")
    // console.log(element)
    console.log(element.getAttribute("id"));
    console.log(element.parentNode.getAttribute("id"));
    if (element.parentNode.getAttribute("id").includes("contact_card_contact_link_")) {
      var type_contact_info = "contact_card_";
      console.log("contact_card is true");
    } else if (element.parentNode.getAttribute("id").includes("see_more_contact_link_")) {
      var type_contact_info = "see_more_";
    }
    console.log("This is the type contact info:::", type_contact_info);
    var person_id = element.parentNode.getAttribute("id").replace(type_contact_info + "contact_link_", "");
    element.parentNode.innerHTML = "";
    console.log(person_id);
    sessionStorage["person_id"] = person_id;
    document.getElementById("loader_link_" + person_id).innerHTML = '<img style="width:20px" src="/static/img/new_loading2.gif"/>';
    if (sessionStorage["current_focus"] == "orgcharts") {
      var linkedin_url = document
        .getElementById("see_more_linkedin_link_" + person_id)
        .getAttribute("onclick")
        .replace("window.open(", "")
        .split(",")[0]
        .replaceAll("'", "")
        .replaceAll(");", "");
    } else if (sessionStorage["current_focus"] == "people") {
      var linkedin_url = document
        .getElementById("contact_card_linkedin_link_" + person_id)
        .getAttribute("onclick")
        .replace("window.open(", "")
        .split(",")[0]
        .replaceAll("'", "")
        .replaceAll(");", "");
    }
    // linkedin_url = document.getElementById('see_more_linkedin_link_'+person_id).getAttribute('onclick').replace("window.open(","").split(',')[0].replaceAll("'","")

    new ManageContactsFetching().setupContactData(person_id, linkedin_url, type_contact_info);
    // setTimeout("new ManageContactsFetching().setupContactData('"+person_id+"',"+'"'+linkedin_url+'"'+'"'+type_contact_info+'"'+");", 100);

    var existing_value = element.getAttribute("data-original-title");
    console.log(existing_value);
    var newValue = existing_value.replace("Click to Copy", "Copied");
    jQuery(element).tooltip("hide");
  }
}

class CompaniesSearchRightBoxes {
  selectAllItemsCompaniesCheckbox(user_input) {
    console.log("Function selectAllItemsCompaniesCheckbox called");
    console.log("Attribute::", user_input.getAttribute("value"));
    if ($("#checkbox_all_items_companies").is(":checked")) {
      var companies = JSON.parse(sessionStorage["company_data"]);
      for (var i = 0; i < companies.length; i++) {
        document.getElementById("checkbox_" + companies[i]["id"]).checked = true;
        var token_obj = {
          company_id: companies[i]["id"],
          company_name: companies[i]["name"],
        };
        updateStorageToken(token_obj, "ajaxQuery");
      }
    } else {
      companies = JSON.parse(sessionStorage["company_data"]);
      for (var i = 0; i < companies.length; i++) {
        document.getElementById("checkbox_" + companies[i]["id"]).checked = false;
        var token_obj = {
          company_id: companies[i]["id"],
          company_name: companies[i]["name"],
        };
        updateStorageToken(token_obj, "ajaxQueryRemove");
      }
    }
    new Tokens().showTokensinUI();
  }
  selectIndividualCompanyCheckbox(user_input) {
    console.log("Function selectIndividualCompanyCheckbox called");
    console.log("Attribute::", user_input.getAttribute("id"));
    var user_input_check_box_company_id = user_input.getAttribute("value");
    var user_input_check_box_company_name = user_input.getAttribute("name");
    var user_input_check_box_id = "checkbox_" + user_input_check_box_company_id;
    // #checkbox_all_items_companies
    if ($("#" + user_input_check_box_id).is(":checked")) {
      var companies = JSON.parse(sessionStorage["company_data"]);
      document.getElementById("checkbox_" + user_input_check_box_company_id).checked = true;
      var token_obj = {
        company_id: user_input_check_box_company_id,
        company_name: user_input_check_box_company_name,
      };
      updateStorageToken(token_obj, "ajaxQuery");
    } else {
      var companies = JSON.parse(sessionStorage["company_data"]);
      document.getElementById("checkbox_" + user_input_check_box_company_id).checked = false;
      var token_obj = {
        company_id: user_input_check_box_company_id,
        company_name: user_input_check_box_company_name,
      };
      updateStorageToken(token_obj, "ajaxQueryRemove");
    }
    new Tokens().showTokensinUI();
  }
}


export { Selections, ManageContactsFetching, CompaniesSearchRightBoxes };
if (typeof window !== 'undefined') {
  window.Selections = Selections;
  window.ManageContactsFetching = ManageContactsFetching;
  window.CompaniesSearchRightBoxes = CompaniesSearchRightBoxes;
}
